import {inject, injectable} from "inversify";
import {action, makeAutoObservable, observable} from "mobx";
import {Bindings} from "data/constants/bindings";
import type {IUserApiProvider} from "data/providers/api/user.api.provider";
import type {IPlayersStore} from "data/stores/players/players.store";
import {DEFAULT_FILTER} from "data/constants";

export type IFilter = Partial<typeof DEFAULT_FILTER>;

export interface IPlayerPoolStore {
	get isOpenPoolModal(): boolean;
	get filter(): IFilter;

	togglePoolModal(filter?: IFilter): void;
	closePoolModal(): void;
}

@injectable()
export class PlayerPoolStore implements IPlayerPoolStore {
	@observable private _isOpenPoolModal: boolean = false;
	@observable private _filter: IFilter = {
		search: "",
	};

	get isOpenPoolModal() {
		return this._isOpenPoolModal;
	}

	get filter() {
		return this._filter;
	}

	constructor(
		@inject(Bindings.UserApiProvider) private _userApi: IUserApiProvider,
		@inject(Bindings.PlayersStore) private _playerStore: IPlayersStore
	) {
		makeAutoObservable(this);
	}

	@action togglePoolModal(filter?: IFilter) {
		this._isOpenPoolModal = !this._isOpenPoolModal;
		this._filter = {...DEFAULT_FILTER, ...(filter || {})};
	}

	@action closePoolModal() {
		this._isOpenPoolModal = false;
		this._filter = {...DEFAULT_FILTER};
	}
}
